import type { JWT } from '@/types/Common'

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    const payload = token.split('.')[1]
    if (!payload) return null

    return JSON.parse(atob(payload))
}

export const nullDate = '0001-01-01'
